/**
 * Wrapper over fetch() used to authenticate the API requests.
 *
 * @param url
 * @param data stringified data
 * @param method
 * @param contentType
 * @returns {Promise<any | never>}
 * @constructor
 */
export function ApiRequest(url, data, method = 'POST', contentType = 'application/json', returnedContentType = 'text/html') {

    let headers = {
        'Accept':           'application/json',
        'Authorization':    'Bearer ' + window.kx_api_token, // Sign api request using user's api_token
        'X-CSRF-Token':     $('meta[name=csrf-token]').attr('content'),
        'X-localization':   $('html[lang]').attr('lang')
    }

    if(contentType) headers['Content-Type'] = contentType

    return fetch(url, {
        credentials: 'same-origin', // 'include', default: 'omit'
        method,                     // 'GET', 'PUT', 'DELETE', etc.
        body: data,                 // Coordinate the body type with 'Content-Type'
        headers: new Headers(headers),
    }).then(response => {
        return (returnedContentType === 'application/json') ? response.json() : response.text()
    })

}
